import { SvgIconProps } from "@mui/material";

import { CaretRight } from "./CaretRight";

export const CaretLeft = ({ sx, ...rest }: SvgIconProps) => {
	return <CaretRight {...rest} sx={{ ...sx, transform: "scale(-1, 1)" }} />;
};

